export class Pagination<T> {
  public pageSize: number = 10;
  public pageNumber: number = 0;
  public totalItems: number = 0;
  public orderBy: string = '';
  public orderDirection: string = '';
  public items: T[] = [];
  public filteredItems: T[] = [];

  constructor(
    pageSize?: number,
    pageNumber?: number,
    totalItems?: number,
    items?: T[],
    filteredItems?: T[],
    pagedQueryResult?: any
  ) {
    this.pageSize = pageSize || this.pageSize;
    this.pageNumber = pageNumber || this.pageNumber;
    this.totalItems = totalItems || this.totalItems;
    this.items = items || this.items;
    this.filteredItems = filteredItems || this.filteredItems;
  }
}

export class PageInfo {
  constructor(public pageSize: number, public pageNumber: number) { }
}

export enum OrderDirection {
  ASC = 'ASC',
  DESC = 'DESC',
}
